<template>
    <div>
        <v-dialog v-model="dialog" persistent max-width="360">
            <v-card>
                <v-card-title><span class="headline">断面図/申請用立面図依頼</span></v-card-title>
                <!-- <v-container> -->
                    <v-card-text>
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-checkbox
                                        v-model="crossSection"
                                        label="D：断面図"
                                        value="1"
                                        hide-details>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <v-checkbox
                                        v-model="elevationDrawing"
                                        label="R：申請用立面図 "
                                        value="1"
                                        hide-details>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="12">
                                    <!-- <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;font-weight:bold;">※共に上限1回</span> -->
                                    <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;font-weight:bold;">※両書類共、１回のみ依頼可能</span><br>
                                    <!-- <span style="font-size:16px;font-family:Arial, Helvetica, sans-serif;color:red;font-weight:bold;">※トライアルエリア以外での依頼は不可</span> -->
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn dark color="red" @click="cancelElevation">キャンセル</v-btn>
                            <v-btn dark color="green" @click="submitElevation" v-if="crossSection != null || elevationDrawing != null">保存</v-btn>
                    </v-card-actions>
                <!-- </v-container> -->
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        dialog: Boolean
    },

    data: () =>({
        crossSection : null,
        elevationDrawing : null
    }),

    computed: {
        ...mapState([
            'cadRequestRevisionContent',
            'editMode',
            'editCadRequestRevisionContent',
        ]),
    },

    methods: {
        toggleDialogElevationRequest(value){
            this.$emit('toggleDialogElevationRequest', value)
        },

        submitElevation(){
            const combinedElev = {
                crossSection : this.crossSection,
                elevationDrawing : this.elevationDrawing
            };
            this.$emit('submitElevation', combinedElev )
            this.toggleDialogElevationRequest(false)
            return;
        },
        cancelElevation(){
            if(!this.editMode){
                this.crossSection = null;
                this.elevationDrawing = null;
                this.$emit('cancelElevation', null)
                this.toggleDialogElevationRequest(false)
            } else {
                this.toggleDialogElevationRequest(false)
            }
        },
    },

    watch: {
        "$store.state.editCadRequestRevisionContent"(val){ 
            this.crossSection = val.cross_section;
            this.elevationDrawing = val.elevation_section;
        }
    }
}
</script>